<template>
  <Head title="Gli Eventi" />
  <h2 class="text-3xl leading-tight font-bold">Gli Eventi</h2>
  <!--  <p class="text-lg mt-4 font-semibold">WIP</p>-->
  <p class="mt-2 leading-relaxed">
    Benvenuti nella nostra pagina degli eventi! Qui potrete trovare tutte le informazioni riguardanti le attività e le
    feste speciali che organizziamo presso la nostra piscina all'aperto.
  </p>

  <p class="mt-2 leading-relaxed">
    <span>Feste a tema:</span>
    Organizziamo regolarmente feste a tema che trasformano la nostra piscina in un'esperienza unica. Dalle feste
    hawaiane alle notti di cinema in piscina, c'è sempre qualcosa di divertente in programma. Vestitevi a tema e
    preparatevi a vivere momenti indimenticabili con gli amici e la famiglia.
  </p>

  <p class="mt-2 leading-relaxed">
    <span>Musica dal vivo:</span>
    Godetevi le vibrazioni della musica dal vivo mentre vi rilassate ai bordi della piscina. Organizziamo serate con
    musicisti locali che vi intratterranno con una varietà di generi musicali, creando l'atmosfera perfetta per una
    serata memorabile.
  </p>

  <p class="mt-2 leading-relaxed">
    <span>Eventi speciali:</span>
    Dalle feste di compleanno alle riunioni di classe, siamo pronti ad ospitare i vostri eventi speciali. Il nostro team
    sarà lieto di lavorare con voi per creare un'esperienza personalizzata che soddisfi le vostre esigenze e renda il
    vostro evento indimenticabile.
  </p>

  <p class="mt-2 leading-relaxed">
    <span>Lezioni e attività:</span>
    Per coloro che vogliono mantenere attivo il corpo e la mente, offriamo una varietà di lezioni e attività. Dalle
    lezioni di acquagym al torneo di pallavolo in piscina, c'è qualcosa per tutti. Consultate il nostro calendario per
    scoprire quali attività sono in programma durante la vostra visita.
  </p>

  <p class="mt-2 leading-relaxed">
    <span>Offerte speciali:</span>
    Non perdetevi le nostre offerte speciali durante gli eventi! Dai cocktail in promozione alle tariffe scontate per
    l'ingresso in piscina, c'è sempre qualcosa di speciale in serbo per i nostri ospiti.
  </p>

  <p class="mt-2 leading-relaxed">
    Unisciti a noi per un'esperienza unica e divertente in piscina. Controllate regolarmente questa pagina per rimanere
    aggiornati sugli eventi in programma e per prenotare il vostro posto!
  </p>
</template>

<script>
import PageLayout from "@/Pages/Home/Shared/PageLayout.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Head,
  },
  layout: PageLayout,
};
</script>
